<template>
  <b-sidebar
    id="add-new-user-sidebar"
    :visible="isAddNewBeneficioSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="(val) => $emit('update:is-add-new-beneficio-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          Agregar Nuevo Beneficio
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />

      </div>

      <!-- BODY -->
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >

          <!-- Titulo de Beneficio -->
          <validation-provider
            #default="validationContext"
            name="Titulo"
            rules="required"
          >
            <b-form-group
              label="Titulo de Beneficio"
              label-for="titulo-beneficio"
            >
              <b-form-input
                id="titulo-beneficio"
                v-model="beneficioData.titulo"
                autofocus
                :state="getValidationState(validationContext)"
                trim
                placeholder="beneficios..."
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- activo de Beneficio (activo, inactivo) -->
          <validation-provider
            #default="validationContext"
            name="activo"
            rules="required"
          >
            <b-form-group
              label="Estado"
              label-for="activo"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="beneficioData.activo"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="statusOptions"
                :reduce="val => val.value"
                :clearable="false"
                input-id="activo"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- descripción -->
          <label for="descripcion">Descripción</label>
          <b-form-textarea
            id="descripcion"
            v-model="beneficioData.descripcion"
            placeholder="Descripción del Beneficio"
            rows="2"
          />

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
            >
              Guardar Beneficio
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              Cancelar
            </b-button>
          </div>

        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormTextarea, BFormInvalidFeedback, BButton,
} from 'bootstrap-vue'

import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref } from '@vue/composition-api'
import { required, alphaNum, email } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
// import store from '@/store'
import { useMutation } from '@vue/apollo-composable'
import ADD_BENEFICIO from '../../../../graphql/cursos/beneficio/AddBeneficio.gql'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormInvalidFeedback,
    BButton,
    vSelect,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewBeneficioSidebarActive',
    event: 'update:is-add-new-beneficio-sidebar-active',
  },
  props: {
    isAddNewBeneficioSidebarActive: {
      type: Boolean,
      required: true,
    },
    statusOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      required,
      alphaNum,
      email,
    }
  },
  setup(props, { emit }) {
    // Use toast
    const toast = useToast()

    const blankBeneficioData = {
      titulo: '',
      descripcion: '',
      activo: '',
    }

    const beneficioData = ref(JSON.parse(JSON.stringify(blankBeneficioData)))
    const resetuserData = () => {
      beneficioData.value = JSON.parse(JSON.stringify(blankBeneficioData))
    }

    const { mutate: sendBeneficio, onDone, onError } = useMutation(ADD_BENEFICIO, () => ({
      variables: beneficioData.value,
    }))

    onDone(() => {
      emit('refetch-data')
    })

    onError(error => {
      toast({
        component: ToastificationContent,
        props: {
          title: error.message,
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      })
    })

    const onSubmit = () => {
      sendBeneficio()

      emit('refetch-data')
      emit('update:is-add-new-beneficio-sidebar-active', false)
      /*
      store.dispatch('app-user/addUser', cursoData.value)
        .then(() => {
          emit('refetch-data')
          emit('update:is-add-new-user-sidebar-active', false)
        })
        */
    }

    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetuserData)

    return {
      beneficioData,
      onSubmit,

      refFormObserver,
      getValidationState,
      resetForm,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
